<template>
  <div id="app">
    <div class="mobile-container">
      <!-- 头部标题区域 -->
      <div class="header-section">
        <div class="title-card">
          <h1 class="main-title">مۇلازىم يەتكۈزگۈچى قوبۇل قىلىش</h1>
          <div class="subtitle">ئۈرۈمچى مۇلازىم سۇپىسى</div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="content-wrapper">
        <!-- 招聘信息卡片 -->
        <div class="info-card">
          <div class="card-header">
            <div class="header-icon">🚚</div>
            <h2>داۋاملىق يەتكۈزگۈچى قوبۇل قىلىمىز</h2>
          </div>

          <!-- 薪酬体系 -->
          <div class="salary-section">
            <h3 class="section-title">💰 مۇكاپات دەرىجىسى</h3>
            <div class="salary-grid">
              <div class="salary-item base">
                <div class="salary-label">ھەر بىر زاكاز</div>
                <div class="salary-value">7 يۈەن</div>
              </div>
              <div class="salary-item bonus">
                <div class="salary-label">600+ زاكاز</div>
                <div class="salary-value">+200 يۈەن</div>
              </div>
              <div class="salary-item bonus">
                <div class="salary-label">800+ زاكاز</div>
                <div class="salary-value">+300 يۈەن</div>
              </div>
              <div class="salary-item bonus">
                <div class="salary-label">1000+ زاكاز</div>
                <div class="salary-value">+400 يۈەن</div>
              </div>
              <div class="salary-item bonus">
                <div class="salary-label">1200+ زاكاز</div>
                <div class="salary-value">+500 يۈەن</div>
              </div>
              <div class="salary-item bonus">
                <div class="salary-label">1500+ زاكاز</div>
                <div class="salary-value">+700 يۈەن</div>
              </div>
            </div>
          </div>

          <!-- 员工福利 -->
          <div class="benefits-section">
            <h3 class="section-title">🎁 تەمىناتلار</h3>
            <div class="benefits-list">
              <div class="benefit-card">
                <div class="benefit-icon">💰</div>
                <div class="benefit-text">
                  خىزمەت فورمسى تولۇقلما مۇكاپاتى 100 يۈەن
                </div>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">🏖️</div>
                <div class="benefit-text">ئايدا تۆت كۈن دەم ئېلىش</div>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">🏠</div>
                <div class="benefit-text">
                  ياتاق (ھەقسىز) ۋە توكسىكىلىت تەمىنلىنىدۇ
                </div>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">🛡️</div>
                <div class="benefit-text">
                  ئىش ئۈستىدە يارىلىنىش ۋە ئىشسىزلىق سۇغۇرتىسىغا قاتناشتۇرۇلىدۇ
                </div>
              </div>
              <div class="benefit-card">
                <div class="benefit-icon">🏥</div>
                <div class="benefit-text">
                  تىز سۈرئەتتە سالامەتلىك كىنىشكىسى چىقىرىشقا ئورۇنلاشتۇرۇلىدۇ
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 联系信息 -->
        <div class="contact-card">
          <div class="contact-title">📞 ئالاقە ئۇچۇرى</div>
          <div class="contact-info">
            <div class="contact-item">
              <span class="contact-label">تېلېفون:</span>
              <a href="tel:18099309040" class="contact-phone">18099309040</a>
            </div>
          </div>
        </div>
        <!-- 品牌特色区域 -->
        <div class="brand-card">
          <div class="brand-logo">
            <img src="../img/mulazim.png" alt="مۇلازىم لوگوسى" />
          </div>
          <div class="brand-slogan">مۇلازىم - سىزنىڭ ئىشەنچلىك شېرىكىڭىز</div>
          <div class="features-row">
            <div class="feature-badge">
              <div class="feature-emoji">⚡</div>
              <div class="feature-name">سۈرئەت</div>
            </div>
            <div class="feature-badge">
              <div class="feature-emoji">⭐</div>
              <div class="feature-name">سۈپەت</div>
            </div>
            <div class="feature-badge highlight">
              <div class="feature-emoji">👑</div>
              <div class="feature-name">ئەلا مۇلازىمەت</div>
            </div>
          </div>
        </div>

        <!-- 行动号召区域 -->
        <div class="cta-card">
          <div class="cta-content">
            <div class="cta-title">سەھنە بىزدىن، تىرىشىش سىزدىن</div>
            <div class="cta-desc">
              پۇل تاپقۇسى بارلارنى قىزغىن قارشى ئالىمىز
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShipperHiring",
  data() {
    return {
      title: "مۇلازىم يەتكۈزگۈچى قوبۇل قىلىش",
    };
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100vh;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  direction: rtl;
  overflow-x: hidden;
}

.mobile-container {
  width: 100%;
  min-height: 100vh;
  padding: 0;
}

/* 头部区域 */
.header-section {
  padding: 20px 15px 30px;
  text-align: center;
}

.title-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  padding: 24px 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.main-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.3;
}

.subtitle {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

/* 内容包装器 */
.content-wrapper {
  padding: 0 5px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 信息卡片 */
.info-card {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  padding: 24px 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;
}

.header-icon {
  font-size: 2rem;
  margin-left: 12px;
}

.card-header h2 {
  font-size: 1.25rem;
  color: #1a1a1a;
  font-weight: 700;
  line-height: 1.3;
}

/* 薪酬部分 */
.salary-section {
  margin-bottom: 32px;
}

.section-title {
  font-size: 1.1rem;
  color: #1a1a1a;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.salary-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.salary-item {
  padding: 16px 12px;
  border-radius: 12px;
  text-align: center;
  transition: all 0.2s ease;
}

.salary-item.base {
  background: linear-gradient(135deg, #4caf50, #45a049);
  color: white;
  grid-column: 1 / -1;
}

.salary-item.bonus {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.salary-item:active {
  transform: scale(0.98);
}

.salary-label {
  font-size: 0.92rem;
  opacity: 0.9;
  margin-bottom: 4px;
  line-height: 1.2;
}

.salary-value {
  font-size: 1.3rem;
  font-weight: 700;
}

/* 福利部分 */
.benefits-section {
  margin-bottom: 0;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.benefit-card {
  display: flex;
  align-items: flex-start;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 12px;
  border-right: 4px solid #667eea;
  transition: all 0.2s ease;
}

.benefit-card:active {
  background: #e3f2fd;
  transform: translateX(-2px);
}

.benefit-icon {
  font-size: 1.4rem;
  margin-left: 12px;
  margin-top: 2px;
  min-width: 32px;
}

.benefit-text {
  font-size: 1.16rem;
  color: #333;
  line-height: 1.4;
  flex: 1;
}

/* 品牌卡片 */
.brand-card {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  padding: 24px 20px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.brand-logo {
  margin-bottom: 16px;
}

.brand-logo img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.brand-slogan {
  font-size: 1rem;
  color: #666;
  margin-bottom: 20px;
  font-weight: 500;
}

.features-row {
  display: flex;
  justify-content: space-around;
  gap: 8px;
}

.feature-badge {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 12px 8px;
  border-radius: 12px;
  flex: 1;
  max-width: 90px;
  transition: all 0.2s ease;
}

.feature-badge.highlight {
  background: linear-gradient(135deg, #ff6b6b, #ee5a24);
  transform: scale(1.05);
}

.feature-badge:active {
  transform: scale(0.95);
}

.feature-emoji {
  font-size: 1.5rem;
  margin-bottom: 6px;
}

.feature-name {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
}

/* 行动号召卡片 */
.cta-card {
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 16px;
  padding: 28px 24px;
  text-align: center;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.cta-content {
  margin-bottom: 24px;
}

.cta-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  line-height: 1.3;
}

.cta-desc {
  font-size: 1rem;
  opacity: 0.9;
  line-height: 1.4;
}

.apply-button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 16px 32px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  backdrop-filter: blur(10px);
}

.apply-button:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.98);
}

.btn-arrow {
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}

.apply-button:active .btn-arrow {
  transform: translateX(-4px);
}

/* 联系信息卡片 */
.contact-card {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.contact-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
  text-align: center;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.contact-label {
  font-size: 0.9rem;
  color: #666;
  font-weight: 500;
}

.contact-value {
  font-size: 0.9rem;
  color: #1a1a1a;
  font-weight: 600;
}

.contact-phone {
  font-size: 0.9rem;
  color: #667eea;
  font-weight: 600;
  text-decoration: none;
  padding: 8px 12px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 6px;
  transition: all 0.2s ease;
  border: 1px solid rgba(102, 126, 234, 0.2);
  font-size: 18px;
}

.contact-phone:active {
  background: rgba(102, 126, 234, 0.2);
  transform: scale(0.98);
}

/* 超小屏幕优化 */
@media (max-width: 360px) {
  .mobile-container {
    padding: 0;
  }

  .content-wrapper {
    padding: 0 12px 20px;
  }

  .header-section {
    padding: 15px 12px 25px;
  }

  .title-card {
    padding: 20px 16px;
  }

  .main-title {
    font-size: 1.3rem;
  }

  .salary-grid {
    grid-template-columns: 1fr;
  }

  .features-row {
    flex-direction: column;
    gap: 12px;
  }

  .feature-badge {
    max-width: none;
  }
}

/* 触摸优化 */
.salary-item,
.benefit-card,
.feature-badge,
.apply-button {
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

/* 滚动优化 */
.mobile-container {
  -webkit-overflow-scrolling: touch;
}

/* 安全区域适配 */
@supports (padding: max(0px)) {
  .mobile-container {
    padding-left: max(15px, env(safe-area-inset-left));
    padding-right: max(15px, env(safe-area-inset-right));
    padding-bottom: max(20px, env(safe-area-inset-bottom));
  }
}
</style>
